import Text from "../../img/sammi.png";
import { useTranslation } from 'react-i18next';

export const AppLinksPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-slate-100">
      <div className="flex flex-col items-center justify-center bg-white rounded-lg shadow-lg p-5 md:p-10 w-full md:w-1/4">
        <div className="flex flex-shrink-0 items-center mb-5">
          <img className="block h-15 w-auto" src={Text} alt="Your Company" />
        </div>

        <h1 className="text-2xl font-bold mb-5">{t('applinks.appStoreLinks')}</h1>

        <p className="text-md text-gray-400 text-center font-bold mb-5">{t('applinks.msg')}</p>

        <div className="flex flex-col items-center justify-center w-full gap-5">
          <a
            href="https://apps.apple.com/us/app/sammi/id6740183991"
            target="_blank"
            rel="noreferrer"
            className="text-blue-400 underline font-bold"
          >
            {t('applinks.ios')}
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.fieldgistix.sammi"
            target="_blank"
            rel="noreferrer"
            className="text-blue-400 underline font-bold"
          >
            {t('applinks.android')}
          </a>
        </div>
      </div>
    </div>
  );
}
